/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_Start_SellingInputs */

const en_footer_link_start_selling = /** @type {(inputs: Footer_Link_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Selling`)
};

const es_footer_link_start_selling = /** @type {(inputs: Footer_Link_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar a vender`)
};

const fr_footer_link_start_selling = /** @type {(inputs: Footer_Link_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer à vendre`)
};

const de_footer_link_start_selling = /** @type {(inputs: Footer_Link_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkaufen starten`)
};

const ja_footer_link_start_selling = /** @type {(inputs: Footer_Link_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`販売を始める`)
};

const zh_footer_link_start_selling = /** @type {(inputs: Footer_Link_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始销售`)
};

const ar_footer_link_start_selling = /** @type {(inputs: Footer_Link_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ البيع`)
};

const id_footer_link_start_selling = /** @type {(inputs: Footer_Link_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai Berjualan`)
};

const it_footer_link_start_selling = /** @type {(inputs: Footer_Link_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia a Vendere`)
};

const ru_footer_link_start_selling = /** @type {(inputs: Footer_Link_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать продавать`)
};

const pt_footer_link_start_selling = /** @type {(inputs: Footer_Link_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar a Vender`)
};

const ko_footer_link_start_selling = /** @type {(inputs: Footer_Link_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매 시작하기`)
};

/**
* | output |
* | --- |
* | "Start Selling" |
*
* @param {Footer_Link_Start_SellingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_link_start_selling = /** @type {((inputs?: Footer_Link_Start_SellingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_Start_SellingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_link_start_selling(inputs)
	if (locale === "es") return es_footer_link_start_selling(inputs)
	if (locale === "fr") return fr_footer_link_start_selling(inputs)
	if (locale === "de") return de_footer_link_start_selling(inputs)
	if (locale === "ja") return ja_footer_link_start_selling(inputs)
	if (locale === "zh") return zh_footer_link_start_selling(inputs)
	if (locale === "ar") return ar_footer_link_start_selling(inputs)
	if (locale === "id") return id_footer_link_start_selling(inputs)
	if (locale === "it") return it_footer_link_start_selling(inputs)
	if (locale === "ru") return ru_footer_link_start_selling(inputs)
	if (locale === "pt") return pt_footer_link_start_selling(inputs)
	return ko_footer_link_start_selling(inputs)
});